module.exports = __webpack_public_path__ + "static/media/privacy.df73cb78.pdf";